import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from "gatsby";
import styled from 'styled-components';
import Spiciness1 from './assets/spiciness-1.png';
import Spiciness2 from './assets/spiciness-2.png';
import Spiciness3 from './assets/spiciness-3.png';

const content = [
  {
    icon: Spiciness1,
    title: "Erotic Audio",
    subtitle: "Romantic and sensual",
    link: (t) => `${t('urls.erotic-audio-stories')}`
  },
  {
    icon: Spiciness2,
    title: "Audio Sex",
    subtitle: "Passionate and bold",
    link: (t) => `${t('urls.audio-sex-stories')}`
  },
  {
    icon: Spiciness3,
    title: "Audio Porn",
    subtitle: "Raw and unapologetic",
    link: (t) => `${t('urls.audio-porn-stories')}`
  }
]

const SpicinessTiles = ({mb, mt}) => {
  const { t } = useTranslation()

  return (
    <Wrapper $mb={mb} $mt={mt}>
      <SectionTitle>{t('spicyTiles.title')}</SectionTitle>
      <SectionSubtitle>{t('spicyTiles.subtitle')}</SectionSubtitle>
      <Container>
      {content.map((item, index) => (
        <StyledButton key={index} to={item.link(t)}>
          <img height={24} src={item.icon} alt={item.title}/>
          <Title>{item.title}</Title>
          <Subtitle>{item.subtitle}</Subtitle>
        </StyledButton>
      ))}
      </Container>
    </Wrapper>
  )
}

export default SpicinessTiles

const Wrapper = styled.div`
  margin-bottom: ${({$mb}) => $mb || '0px'};
  margin-top: ${({$mt}) => $mt || '0px'};
`

const SectionSubtitle = styled.h3`
  font-size:12px;
  font-family: 'Poppins';
  margin: 0px;
  margin-bottom: 20px;
  text-align: center;
  
`

const SectionTitle = styled.h2`
  text-align: center;
  font-size:24px;
  margin: 0px 0px;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  max-width: 48rem;
  margin: 0 auto;
  @media (min-width: 640px) {
    flex-direction: row;
  }
`

const StyledButton = styled(Link)`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background-color: #F19D9A2E;
  border: 2px solid #F19D9A;
  border-radius: 0.375rem;
  transition: background-color 0.3s ease;
  text-decoration: none;
  &:hover {
    background-color: #F19D9A;
  }
`

const Title = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0;
`

const Subtitle = styled.p`
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
`